<template>
  <div class="chart-box">
    <div class="label-container">
      <label class="label">{{ chartTitle }}</label>
      <label class=sublabel> {{chartSubtitle}} </label> 
      <div v-if="subLabelType=='singleLabel'" class="sublabel-container">
        <div>
          <button :class="{ button: true, selected: chartData.category === m }" v-for="m in ['count', 'percent']" @click="_setMeasurement(m, chartData)">{{ m }}</button>
        </div>
      </div>
    </div>
    <template v-if="dataExists(chartData)">
      <HorizontalBarChart :category="`${chartData.category}`" :chartData="chartData"> </HorizontalBarChart>
    </template>
    <template v-else>
      <img class="non-data" v-if="noDataImg" :src="noDataImg" alt="No data" />
      <p class="non-data">No data available.</p>
    </template>
  </div>
</template>

<script>
import HorizontalBarChart from './../../charts/HorizontalBarChart';
import chartBoxMixin from './mixin/chart-box-mixin';
export default {
    name: 'HorizontalBarChartBox',
    mixins: [
        chartBoxMixin
    ],
    components: {
        HorizontalBarChart,   
    },
    props: {
        chartData: {
          default: () => ({}),
          type: Object
        },
        chartTitle: { 
          type: String,
          required: true,
        },
        chartSubtitle: { 
          type: String,
        },
        subLabelType: { 
          type: String,
          default: 'singleLabel'
        },
    },
    created() { 
        
    },
   
    methods: {
        
        dataExists() {
          return true; // to do if need to use this for real - add a function specific to this dataset format
        }
        
    }
};
</script>

<style lang="scss" scoped>
@import "SrcRoot/modules/Campaign/components/monitor/scss/monitor.scss";
</style>
